import React from 'react';

// Site-wide "DEMO" pill rendered next to the brand logo on every screen.
// Signals to SFI / conference audiences that the dashboard is a prototype,
// not a production product. Yellow chrome matches the Scenario Mode +
// "Pilot preview" insight-card accent so the pill reads as the same family
// of "this is a preview" cues already in the design system.
export const DemoBadge: React.FC = () => (
  <span
    className="inline-flex items-center px-1.5 py-0.5 rounded border border-figma-yellow/60 bg-figma-yellow/10 text-figma-yellow text-[9px] font-roboto-mono font-bold uppercase tracking-[0.12em] leading-none"
    aria-label="This dashboard is a demo prototype"
    title="Demo / Prototype — not a production product"
  >
    Demo
  </span>
);
